import * as React from "react";
import RadioGroup, { IRadioInput } from "./RadioGroup";

const defaultPickListOptions: IRadioInput[] = [
	{
		id: "",
		label: "",
		value: "",
	},
];

interface IProps {
	// passed props
	value?: string;
	onChange: (value: {}) => void;
	title?: string;
	name: string;
	className?: string;
	required?: boolean;
	pickListCode?: string;
	// own props
	pickListItems: PickListItemResponseDTO[];
}

class PickListRadioGroup extends React.Component<IProps> {
	private pickListOptions = defaultPickListOptions;
	constructor(props: IProps) {
		super(props);
	}

	public componentDidMount() {
		this.pickListOptions = this.props.pickListItems.map(
			(p: PickListItemResponseDTO) => {
				return this.translatePickListItemToIRadioInput(p);
			}
		);
	}

	public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
		this.pickListOptions = nextProps.pickListItems.map(
			(p: PickListItemResponseDTO) => {
				return this.translatePickListItemToIRadioInput(p);
			}
		);
	}

	public render() {
		return (
			<RadioGroup
				title={this.props.title as string}
				name={this.props.name}
				radioOptions={this.pickListOptions}
				onChange={this.props.onChange}
				className={this.props.className}
				required={this.props.required}
			/>
		);
	}

	private translatePickListItemToIRadioInput(
		pickListItem: PickListItemResponseDTO
	): IRadioInput {
		const returnItem: IRadioInput = {
			id: `${this.props.name}_${pickListItem.id}`,
			label: pickListItem.description as string,
			value: pickListItem.id!.toString(),
		};

		return returnItem;
	}
}

export default PickListRadioGroup;
